import { type AxiosError } from 'axios'
import { useUiStore } from '@/stores'
import { type ApiError, type UiStore } from '@/types'

/**
 * Extracts and shows error message from error object and converts it to user-friendly text if needed
 * @param {ApiError | AxiosError | Error} e - error object
 */
export const processApiError = (errorRaw: AxiosError | Error | ApiError): void => {
    const errorApi: ApiError = errorRaw as ApiError

    const message: string =
        errorApi.response?.data.error?.message ||
        errorApi.response?.data.message ||
        errorApi.response?.data.detail ||
        (errorRaw as AxiosError).message ||
        (errorRaw as Error).message

    const uiStore: UiStore = useUiStore()
    uiStore.showError(message)
}
